import { useTheme } from "@mui/material";
import { useEffect, useState } from "react";

/**
 * CodeBlock component with dynamic syntax highlighting
 * Uses react-syntax-highlighter with dynamic imports to avoid bundle size issues
 * Uses the dracula theme for better contrast
 */
const CodeBlock = ({ code }) => {
  const theme = useTheme();
  const [SyntaxHighlighter, setSyntaxHighlighter] = useState(null);
  const [codeTheme, setCodeTheme] = useState(null);

  useEffect(() => {
    const loadComponents = async () => {
      try {
        // Use PrismAsync for better loading performance
        const { PrismAsync } = await import("react-syntax-highlighter");
        // Import dracula theme which has excellent contrast
        const { dracula } = await import(
          "react-syntax-highlighter/dist/esm/styles/prism"
        );

        setSyntaxHighlighter(() => PrismAsync);
        setCodeTheme(dracula);
      } catch (error) {
        console.error("Failed to load syntax highlighter:", error);
      }
    };

    loadComponents();
  }, []);

  // Simple fallback style
  const fallbackStyle = {
    backgroundColor: "#282a36", // Dracula background color
    color: "#f8f8f2",
    padding: "16px",
    borderRadius: "8px",
    fontSize: "0.8rem",
    lineHeight: 1.5,
    overflow: "auto",
    fontFamily: "monospace",
    margin: 0,
  };

  if (!SyntaxHighlighter || !codeTheme) {
    return <pre style={fallbackStyle}>{code}</pre>;
  }

  return (
    <SyntaxHighlighter
      language="jsx"
      style={codeTheme}
      customStyle={{
        margin: 0,
        borderRadius: "8px",
        fontSize: "0.8rem",
        lineHeight: 1.6,
        // Ensure no border or outline is visible
        border: "none",
        outline: "none",
        boxShadow: "none",
        backgroundColor: "#282a36", // Enforce dracula background
      }}
      showLineNumbers={false}
      wrapLongLines={true}
    >
      {code}
    </SyntaxHighlighter>
  );
};

export default CodeBlock;
